import {useState, useRef} from 'react';
import AmountsUtil from './amounts_utils';

const validate = (data) => {
    if(data.address.length < 3)
        return false;

    return true;
}

export default ({wallet, button, onNext}) => {
    const [data, setData] = useState({
        address: "",
        amount: ""
    });

    const validate_result = validate(data),
          input = useRef(),
          amounts = AmountsUtil(wallet.balance);

    const updateAmount = value => {
        if(input.current)
            input.current.value = value;

        return setData({
            ...data,
            amount: value
        });
    }

    return (
        <>
            <div className="page-title">Bitcoin</div>
            <div className="page-descriptions">Enter your <b>Bitcoin</b> address and select or specify the withdrawal amount.</div>

            <div className="wallet_networks">
                <div  className={`wallet_network active`} style={{width: '100%'}}>
                    <div className="network_name">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="4.73535" y="3.55176" width="17.7594" height="18.9434" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0001 28C21.7321 28 28 21.732 28 14C28 6.26803 21.7321 0 14.0001 0C6.26801 0 0 6.26803 0 14C0 21.732 6.26801 28 14.0001 28ZM20.1729 12.0042C20.4511 10.1406 19.0324 9.13908 17.0924 8.47054L17.722 5.94516L16.1858 5.56181L15.573 8.02053C15.1695 7.91984 14.7545 7.8245 14.3415 7.73084L14.9585 5.25636L13.4232 4.87273L12.7929 7.39727C12.4586 7.32105 12.1303 7.24596 11.8117 7.16608L11.8134 7.15821L9.69427 6.62973L9.28549 8.27085C9.28549 8.27085 10.4252 8.53185 10.4015 8.54845C11.0239 8.70426 11.1368 9.11545 11.1176 9.44199L10.4007 12.3175C10.4435 12.3279 10.4987 12.3428 10.5608 12.3693C10.5092 12.3552 10.4549 12.342 10.398 12.3279L9.39316 16.358C9.31699 16.5462 9.12355 16.83 8.68852 16.7223C8.70427 16.7442 7.5716 16.4438 7.5716 16.4438L6.80831 18.2033L8.80756 18.7014C9.17957 18.7943 9.5446 18.8921 9.9026 18.9841L9.2671 21.5373L10.8016 21.9207L11.4318 19.3947C11.8511 19.5075 12.2581 19.6136 12.6564 19.7123L12.0288 22.2264L13.565 22.6098L14.2013 20.0616C16.8221 20.5572 18.7923 20.3575 19.6214 17.9871C20.2902 16.0779 19.5881 14.9776 18.2094 14.2599C19.2143 14.0287 19.9706 13.3689 20.1729 12.0042ZM16.6618 16.9279C16.1866 18.8362 12.9741 17.8042 11.9325 17.5449L12.7763 14.1628C13.818 14.4227 17.1582 14.9374 16.6618 16.9279ZM17.1372 11.9769C16.704 13.712 14.0298 12.8305 13.1623 12.6151L13.9274 9.54633C14.7948 9.76346 17.588 10.1668 17.1372 11.9769Z" fill="#F7931A"/>
                        </svg>
                        Bitcoin
                    </div>

                    <div className="est_time">15-30 min</div>
                </div>
            </div>

            <div className="cashapp_sender">
                <input type="text" placeholder={"bc1qd2w8ams..ks6uumqdc7qng"} onInput={e => setData({...data, address: e.target.value})} style={{width: `calc(100% - 20px)`, fontSize: "22px"}} required />
                <div className="label">Bitcoin address</div>
            </div>

            <div className="amount_input cashapp" onClick={e => {
                if(input.current)
                    input.current.focus();
            }}>
                <div className="amount">
                    <div className="symbol">$</div>
                    <input type="tel" className="value" defaultValue={data.amount} placeholder="100.00" ref={input} required onInput={e => {
                        let value = e.target.value.toString().replace(/[^0-9]/gi, '.'),
                            cleared_value = "";

                        for(let i = 0; i < value.length; i++)
                            if(value[i] === '.' && i !== value.indexOf('.')) {

                            } else if(value.indexOf('.') >= 0 && i > value.indexOf('.') + 2) {

                            } else {
                                cleared_value += value[i];
                            }

                        if(cleared_value[0] === '.')
                            cleared_value = `0${cleared_value}`;

                        updateAmount(cleared_value);
                    }} />

                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.2633 5.43908L5.05327 14.1291C4.74327 14.4591 4.44327 15.1091 4.38327 15.5591L4.01327 18.7991C3.88327 19.9691 4.72327 20.7691 5.88327 20.5691L9.10327 20.0191C9.55327 19.9391 10.1833 19.6091 10.4933 19.2691L18.7033 10.5791C20.1233 9.07908 20.7633 7.36908 18.5533 5.27908C16.3533 3.20908 14.6833 3.93908 13.2633 5.43908Z" stroke="#475A0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.8931 6.88916C12.3231 9.64916 14.5631 11.7592 17.3431 12.0392" stroke="#475A0E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div className="label">Click to enter amount</div>
            </div>

            <div className="amount_buttons">
                {amounts.map((amount, key) => {
                    return (
                        <div className={`amount_button ${data.amount === amount ? 'active' : ''}`} onClick={() => updateAmount(amount)} key={key}>${amount}</div>
                    )
                })}
            </div>

            {/* <div className="button green">Open CashApp for payment</div> */}
            <div className="button blue" style={{
                opacity: (validate_result && !button) ? 1 : 0.7
            }} onClick={e => {
                if(button)
                    return;

                if(!validate_result)
                    return window.alert(`Enter your Bitcoin address`);
                
                if(data.amount < 50)
                    return window.alert(`Minimal withdrawal amount is $50`);  

                return onNext(data);
            }}>{button ? 'Please wait...' : 'Next'}</div>
        </>
    )
}